import Vue from "vue";

export const messages = {
  en: {
    languages: { label: "Language", en: "English", zhCN: "Chinese" },
    addMarkers: {
      title: "Add Mortar/Target",
      instructions: "Press icon buttons to cycle through marker colors",
      mortarPosition: "Mortar pos",
      targetPosition: "Target pos",
      close: "Close",
    },
    github: {
      title: "View Code on GitHub",
      subtitle: "Submit issues, contribute, etc.",
    },
    error: {
      occurred: "An error occurred. Please click here and fill out the error report.",
      noStorage: "No localStorage!",
      notSaved: "Your settings won't be saved",
    },
    modes: {
      advanced: "Advanced Mode",
      advancedDescription: "Place FOBs, multiple markers & targets and create LINE and AREA fire",
      setMortar: "Set mortar type",
      setTarget: "Set target type",
      twoTargets: "Two target markers required",
      roundSpacing: "Round Spacing",
    },
    settings: {
      map: "Map Settings",
      grid: "Show Keypad Grid",
      heightmap: "Show Heightmap",
      locations: "Show Locations",
      allRanges: "Show all Mortar Circles",
      activeOnly: "instead of active only",
      pinSize: "Pin Size",
      performance: "Performance Settings",
      delay: "Delay mil update on drag",
      performanceHack: "performance hack",
      hideLoading: "Hide loading bar",
      zoomDelay: "reduces zoom delay",
      removePins: "Remove Pins",
    },
    targetTypes: { POINT: "Point", LINE: "Line", AREA: "Area" },
    netlify: "Deploys by Netlify",
  },
  "zh-CN": {
    languages: { label: "语言", en: "英语", zhCN: "中文" },
    addMarkers: {
      title: "添加迫击炮/目标",
      instructions: "点击图标按钮切换标记颜色",
      mortarPosition: "迫击炮位置",
      targetPosition: "目标位置",
      close: "关闭",
    },
    github: {
      title: "在 GitHub 上查看代码",
      subtitle: "提交问题、参与贡献等",
    },
    error: {
      occurred: "发生错误。请点击此处并填写错误报告。",
      noStorage: "没有 localStorage！",
      notSaved: "设置不会被保存",
    },
    modes: {
      advanced: "高级模式",
      advancedDescription: "放置 FOB、多个标记和目标，并创建线性或区域射击",
      setMortar: "设置迫击炮类型",
      setTarget: "设置目标类型",
      twoTargets: "需要两个目标标记",
      roundSpacing: "轮次间距",
    },
    settings: {
      map: "地图设置",
      grid: "显示键盘网格",
      heightmap: "显示高度图",
      locations: "显示地点",
      allRanges: "显示所有迫击炮射程圈",
      activeOnly: "而不是仅显示当前射程圈",
      pinSize: "标记大小",
      performance: "性能设置",
      delay: "拖动时延迟毫秒数更新",
      performanceHack: "性能优化",
      hideLoading: "隐藏加载条",
      zoomDelay: "减少缩放延迟",
      removePins: "移除标记",
    },
    targetTypes: { POINT: "点射", LINE: "线射", AREA: "区域射击" },
    netlify: "由 Netlify 部署",
  },
};

const STORAGE_KEY = "locale";
const supportedLocales = Object.keys(messages);
const browserLocale = typeof navigator !== "undefined" ? navigator.language : "en";
const savedLocale = typeof localStorage !== "undefined" ? localStorage.getItem(STORAGE_KEY) : undefined;
let initialLocale = "en";
if (savedLocale && supportedLocales.indexOf(savedLocale) !== -1) {
  initialLocale = savedLocale;
} else if (browserLocale.toLowerCase().indexOf("zh") === 0) {
  initialLocale = "zh-CN";
}

const state = Vue.observable({ locale: initialLocale });

function translate(locale, key) {
  const value = key.split(".").reduce((current, part) => (
    current === undefined ? undefined : current[part]
  ), messages[locale]);
  return value === undefined ? key : value;
}

const i18n = {
  get locale() { return state.locale; },
  set locale(value) {
    if (supportedLocales.indexOf(value) === -1) return;
    state.locale = value;
    if (typeof localStorage !== "undefined") localStorage.setItem(STORAGE_KEY, value);
    if (typeof document !== "undefined") document.documentElement.lang = value;
  },
  get locales() { return supportedLocales; },
  t(key) { return translate(state.locale, key); },
};

Vue.prototype.$t = key => i18n.t(key);
Vue.prototype.$i18n = i18n;
if (typeof document !== "undefined") document.documentElement.lang = initialLocale;

export default i18n;
